import { getQueryKeys } from "@/app/_module/services/helper";

const namespace = "subscription-plans";

const subscriptionPlanQueryKeys = {
  ...getQueryKeys(namespace),

  // Custom function keys for subscription-plans-specific functionality
  all: [namespace] as const,
  lists: () => [namespace, "list"] as const,
  list: (filters: { page?: number; limit?: number; search?: string }) =>
    [namespace, "list", filters] as const,
  details: () => [namespace, "detail"] as const,
  detail: (id: string) => [namespace, "detail", id] as const,
  stats: () => [namespace, "stats"] as const,
  myActiveSubscription: () => [namespace, 'my-active-subscription'] as const,
};

export default subscriptionPlanQueryKeys; 